<footer class="footer" *transloco="let t; read: 'footer'">
  <div class="container">
    <div class="row py-4">
      <!-- Logo and Social Media -->
      <div class="col-md-3 ta-center">
        <div class="footer-logo">
          <img src="assets/images/all-img/Isolation_Mode.svg" alt="Moawen Logo" class="img-fluid" />
        </div>
        <p class="mt-3">{{t('connectWithUs')}}</p>
        <div class="social-icons d-flex justify-content-center justify-content-md-start gap-2 mb-4">
          <a href="#" class="social-link">
            <img src="assets/images/all-img/facebook.svg" alt="Facebook Logo" class="img-fluid" />
          </a>
          <a href="#" class="social-link">
            <img src="assets/images/all-img/linkindin.svg" alt="Facebook Logo" class="img-fluid" /></a>
          <a href="#" class="social-link">
            <img src="assets/images/all-img/twiter.svg" alt="Facebook Logo" class="img-fluid" /></a>
          <a href="#" class="social-link">
            <img src="assets/images/all-img/instagram.svg" alt="Facebook Logo" class="img-fluid" /></a>
          <a href="#" class="social-link">
            <img src="assets/images/all-img/youtube.svg" alt="Facebook Logo" class="img-fluid" /></a>
        </div>
      </div>

      <!-- Department & Services -->
      <div class="col-md-3 ta-center">
        <h5>{{t('departmentServices')}}</h5>
        <ul class="list-unstyled">
          <li><a href="#">{{t('laborerInterview')}}</a></li>
          <li><a href="#">{{t('authenticateContract')}}</a></li>
          <li><a href="#">{{t('labourDisputes')}}</a></li>
          <li><a href="#">{{t('labourInspection')}}</a></li>
          <li><a href="#">{{t('labourRelation')}}</a></li>
          <li><a href="#">{{t('laborWages')}}</a></li>
          <li><a href="#">{{t('occupationalHealth')}}</a></li>
        </ul>
      </div>

      <!-- Quick Links -->
      <div class="col-md-3 ta-center">
        <h5>{{t('quickLinks')}}</h5>
        <ul class="list-unstyled">
          <li><a href="#">{{t('certifiedAgencies')}}</a></li>
          <li><a href="#">{{t('aboutUs')}}</a></li>
          <li><a href="#">{{t('announcements')}}</a></li>
          <li><a href="#">{{t('newsEvents')}}</a></li>
        </ul>
      </div>

      <!-- Other Pages -->
      <div class="col-md-3 ta-center">
        <h5>{{t('otherPages')}}</h5>
        <ul class="list-unstyled">
          <li><a href="#">{{t('faqs')}}</a></li>
          <li><a href="#">{{t('helpCenter')}}</a></li>
          <li><a href="#">{{t('contact')}}</a></li>
          <li><a href="#">{{t('termsAndConditions')}}</a></li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Bottom Section -->
  <div class="footer-bottom text-center py-3">
    <p class="mb-0">{{t('copyRight')}}</p>
  </div>
</footer>